module.exports = __WEBPACK_EXTERNAL_MODULE_143__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/scheduler/queue"
// module id = 143
// module chunks = 0